import React from 'react';
import '../App.css';

class Menu extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            link: ['#about', '#services', '#contact']
        }
    }

    render(){      
        return(          
            <div className="container-fluid center">
        <nav className="menu">
            <h1 className="menu__logo"> </h1>
            <div className="menu__right">
                <ul className="menu__list">
                    <li className="menu__list-item"><a className="menu__link menu__link--active" href={this.state.link[0]}>About</a></li>
                    <li className="menu__list-item"><a className="menu__link menu__link--active" href={this.state.link[1]}>Services</a></li>
                    <li className="menu__list-item"><a className="menu__link menu__link--active" href={this.state.link[2]}>Contact</a></li>
            </ul> 
            </div>
        </nav>
    </div>
        )
    }
}

export default Menu;
